import React               from "react";
import View                from "./view";
import Spinner             from "../components/spinner";
import List                from "../components/list";
import ListItem            from "../components/list-item";
import messages            from "../../../messages";
import config              from "../../../config";
import { POINT_TYPE_FREE } from "../../../point-types";

export default class DateView extends View {
    static get title () {
        return "выберите дату приема";
    }

    static get titleShort() {
        return "дата";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            clinic: React.PropTypes.number.isRequired,
            openWithoutDoctor: React.PropTypes.number,
            doctor: React.PropTypes.oneOfType([
                React.PropTypes.string,
                React.PropTypes.number,
            ]),
        });
    }

    getMonday(date) {
        const day = date.getDay();
        const diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        return new Date(date.setDate(diff));
    }

    constructor (props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
            itemsClinic: null,
            isLoading: false,
            buttonName: "показать еще",
            showHitMessage: false,
            doctor: !!this.props.doctor ? this.props.doctor : '',
        });

        this.scheduleScroll = 0;
        this._isMounted = false;
    }

    handleResponse(responseJson, scheduleScroll) {
        const items = [];
        const { dates, captions, grid, M } = responseJson;

        for (let i = 0; i < M; i++) {
            items.push({
                caption: captions[i],
                date: dates[i],
                isEmpty: !(grid[i].some((element) => element.status === POINT_TYPE_FREE)),
                scheduleScroll: scheduleScroll,
            });
        }

        return items;
    }

    fetchClinics() {
        this.hideErrorMessage();
        this.setState({
            itemsClinic: null,
        });

        const url = `${config.dataUrl}api.php?function=branches`;

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    this.setState({
                        itemsClinic: responseJson.clinics,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }


    fetchData(scheduleScroll) {
        this.hideErrorMessage();
        this.setState({
            isLoading: true
        });

        if (scheduleScroll === 0) {
            this.setState({
                items: null
            });
        }

        let url = `${config.dataUrl}api.php?function=schedule`  +
            `&clinic=${this.props.clinic}` +
            `&service=${this.props.service}` +
            `&length=${config.scheduleLength}` +
            `&scroll=${scheduleScroll}`;
        url += this.props.openWithoutDoctor ?  '' : `&doctor=${this.state.doctor}` ;
        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status){
                    let itemsCurrent = this.handleResponse(responseJson, scheduleScroll);
                    this.setState({
                        showHitMessage: (itemsCurrent.every((element) => element.isEmpty))
                    });
                    if (this.state.items === null) {

                        this.setState({
                            isLoading: false,
                            items: this.handleResponse(responseJson, scheduleScroll),
                            buttonName: "показать еще",
                        });
                    } else {
                        this.setState({
                            isLoading: false,
                            items: this.state.items.concat(this.handleResponse(responseJson, scheduleScroll)),
                            buttonName: "показать еще",
                        });
                    }
                }else{
                    if (this.state.items === null) {
                        this.setState({
                            isLoading: false,
                            items: this.handleResponse(responseJson, scheduleScroll),
                            buttonName: "нет расписания",
                        });
                    } else {
                        this.setState({
                            isLoading: false,
                            items: this.state.items,
                            buttonName: "нет расписания",
                        });
                    }
                }

            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
                this.setState({
                    isLoading: false
                });
            }
        });
    }

    componentDidMount() {
        this._isMounted = true;
        this.scheduleScroll = 0;

        this.fetchClinics();
        this.fetchData(this.scheduleScroll);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchClinics();
        this.fetchData(this.scheduleScroll);
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null || this.state.itemsClinic === null) {
            return <Spinner />;
        }

        const elements = this.state.items.map((item, key) => {
            const empty = item.isEmpty;
            if (!empty) {
                return (
                    <ListItem key={key} isActive={!empty} hasStatusIndicator={true} onClick={() => {
                        this.props.gotoNextView({
                            breadcrumbName: item.caption,
                            nextView: "TimeView",
                            props: {
                                date: item.date,
                                scheduleScroll: item.scheduleScroll,
                            }
                        });
                    }}>

                        {item.caption}
                    </ListItem>
                );
            } else {
                return null;
            }

        });

        return <List>{elements}</List>;
    }

    handleMoreButtonClick() {
        this.scheduleScroll++;
        this.fetchData(this.scheduleScroll);
    }

    render() {
        let phoneNumber = 123;
        let phoneUrl = ""
        if (this.state.itemsClinic !== null){
            phoneNumber = this.state.itemsClinic.reduce((acc,item) => Number(item.id) === Number(this.props.clinic) ? item.phone : acc, "")
            phoneUrl = "tel:" + phoneNumber.replace(/\D+/g,"");

        }
        return (
            <div className="appointment-view appointment-view--date">
                {(this.state.showHitMessage|| this.state.buttonName === 'нет расписания') ? <div className="empty-schedule">
                    Если Вы не нашли нужную Вам услугу или удобное время - свяжитесь с нами по телефону <a href={phoneUrl}> {phoneNumber}</a>. Наши администраторы всегда помогут Вам!
                </div> : null}
                {this.renderContent()}

                {this.state.items !== null ? <button
                    key={"more-button"}
                    disabled={this.state.isLoading}
                    className="appointment-view__load-more-button"
                    onClick={() => { this.handleMoreButtonClick(); }}>
                    {this.state.buttonName}

                </button> : null}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/date.js
 **/